import { recommendationLevelColor, signedScore } from '@/common/app/modules/media/sentiment'
import { SentimentCompetitor } from '@/common/model/media/sentiment'

import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

import GeoSection from '@/components/container/modules/mediaGeo/common/GeoSection'

interface Props {
  competitors: SentimentCompetitor[]
}

// 各ブランドのセンチメントスコアと推奨度の比較テーブル
const SentimentCompetitorTable = ({ competitors }: Props) => (
  <GeoSection title='競合比較' noPadding>
    <table className='w-full border-collapse'>
      <thead>
        <TableRow head>
          <TableHeadItem type='thin'>
            <Text size={12} color={TextColor.SECONDARY}>
              ブランド
            </Text>
          </TableHeadItem>
          <TableHeadItem type='thin' width={160}>
            <Text size={12} color={TextColor.SECONDARY}>
              センチメントスコア
            </Text>
          </TableHeadItem>
          <TableHeadItem type='thin' width={88}>
            <Text size={12} color={TextColor.SECONDARY}>
              推奨度
            </Text>
          </TableHeadItem>
        </TableRow>
      </thead>
      <tbody>
        {competitors.map((comp, i) => (
          <TableRow key={i}>
            <TableRowItem align='middle'>
              <Text size={14}>{comp.brand}</Text>
            </TableRowItem>
            <TableRowItem width={160} align='middle'>
              <Text size={14}>{signedScore(comp.score)}</Text>
            </TableRowItem>
            <TableRowItem width={88} align='middle'>
              <Text
                size={14}
                weight='bold'
                color={recommendationLevelColor(comp.recommendation_level)}
              >
                {comp.recommendation_level || '-'}
              </Text>
            </TableRowItem>
          </TableRow>
        ))}
      </tbody>
    </table>
  </GeoSection>
)

export default SentimentCompetitorTable
